module.exports = __webpack_public_path__ + "img/ico_menual03_off.56b287be.svg";